import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';

export const useResolveShareCode = (code: string) => {
  const trpcAPI = useTRPCAPI();
  return useTRPCQuery(
    trpcAPI.share.resolveShareCode.queryOptions(
      { code },
      {
        // Re-signed JWT is fine to cache for the SPA session — it's regenerated
        // server-side on every call but the underlying params don't change.
        staleTime: Infinity,
        retry: false,
      }
    )
  );
};
